
import React, { useMemo } from "react";
import { useTable } from "react-table";
import PropTypes from "prop-types";

const IncomingPackagesTable = ({ data }) => {
    const columns = useMemo(
        () => [
            { Header: "Sr", accessor: (_, i) => i + 1 },
            { Header: "Package #", accessor: "inspectionNumber" },
            { Header: "Site Name", accessor: "jobSiteName" },
            { Header: "Type", accessor: "type" },
            { Header: "Form Name", accessor: "formName" },
            { Header: "Stage Level", accessor: "stageLevel" },
        ],
        []
    );

    const tableInstance = useTable({ columns, data });
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = tableInstance;

    const minRows = 6;
    const emptyRows = Array.from({ length: Math.max(0, minRows - rows.length) });

    return (
        <div
            style={{
                width: "100%",
                overflowX: "auto",
                overflowY: "auto",
                borderRadius: "10px",
                // border: "1px solid #ddd",
                // backgroundColor: "#fff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                maxHeight: "60vh",
                scrollbarWidth: "thin",
                WebkitOverflowScrolling: "touch",
            }}
            className="dark-panel"
        >
            <table
                {...getTableProps()}
                className="table table-striped table-hover mb-0"
                style={{
                    width: "max-content", // ✅ ensures horizontal scroll triggers properly
                    minWidth: "700px",
                    borderCollapse: "collapse",
                }}
            >
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()} key={headerGroup.id}>
                            {headerGroup.headers.map((column) => (
                                <th
                                    {...column.getHeaderProps()}
                                    key={column.id}
                                    style={{
                                        backgroundColor: "#1c4e80",
                                        color: "#fff",
                                        position: "sticky",
                                        top: 0,
                                        zIndex: 2,
                                        textAlign: "left",
                                        padding: "10px 12px",
                                        whiteSpace: "nowrap",
                                        fontSize: "0.9rem",
                                    }}
                                >
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>

                <tbody {...getTableBodyProps()}>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()} key={row.id}>
                                {row.cells.map((cell) => (
                                    <td
                                        {...cell.getCellProps()}
                                        key={cell.column.id}
                                        style={{
                                            padding: "10px 12px",
                                            borderBottom: "1px solid #e5e5e5",
                                            whiteSpace: "nowrap",
                                            fontSize: "0.9rem",
                                        }}
                                    >
                                        {cell.render("Cell")}
                                    </td>
                                ))}
                            </tr>
                        );
                    })}

                    {/* Empty rows for consistent height */}
                    {emptyRows.map((_, index) => (
                        <tr key={`empty-${index}`}>
                            {columns.map((_, i) => (
                                <td key={i} style={{ height: "40px" }}>&nbsp;</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

IncomingPackagesTable.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            stageId: PropTypes.string,
            inspectionNumber: PropTypes.string,
            jobSiteName: PropTypes.string,
            type: PropTypes.string,
            formName: PropTypes.string,
            stageLevel: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        })
    ).isRequired,
};

export default IncomingPackagesTable;
